{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-120200",
  "definition": "[120200] Disclosure - Director business review",
  "sheetId": "DirectorBusinessReview",
  "label": "Director Business Review",
  "controls": [
    {
      "qname": "section:DirectorsBusinessReviewDisclosure",
      "label": "Disclosure on directors business review",
      "type": "SectionHeader",
      "ui": { "control": "section-header", "level": 1 }
    },
    {
      "qname": "ssmt:DisclosureOfStatementByDirectorsForBusinessReviewExplanatory",
      "label": "Disclosure of statement by directors for business review",
      "type": "TextBlock",
      "ui": { "control": "richtext", "rows": 15 },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfBusinessReviewEitherOnEnvironmentEmployeesOrSocialAndCommunityIssues",
      "label": "Disclosure of business review either on environmental, employees or social and community issues",
      "type": "String",
      "ui": { "control": "text", "maxLength": 255 },
      "validators": [{ "name": "maxLength", "value": 255 }],
      "error": {
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:EnvironmentalMatters",
      "label": "Environmental matters",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:CompanysEmployees",
      "label": "Company's employees",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:SocialAndCommunityIssues",
      "label": "Social and community issues",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:Others",
      "label": "Others",
      "type": "YesNoItemType",
      "ui": { "control": "select", "enumSource": "type:YesNoItemType" },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt:DisclosureOfOtherBusinessReviewApplied",
      "label": "Disclosure of other business review applied",
      "type": "String",
      "ui": { "control": "text", "maxLength": 255 },
      "validators": [
        { "name": "maxLength", "value": 255 }
      ],
      "error": {
        "maxlength": "Name must not exceed 255 characters."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "section:CompanyEmployeesDetails",
      "label": "Details of company's employees",
      "type": "SectionHeader",
      "ui": { "control": "section-header", "level": 1 }
    },
    {
      "qname": "ssmt:NumberOfEmployees",
      "label": "Number of employees",
      "type": "NonNegativeInteger",
      "ui": { "control": "number", "useGrouping": true, "positiveWholeNumber": true },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "min", "min": 0 },
        { "name": "pattern", "pattern": "^[0-9]+$", "message": "Please enter a whole number only (no decimal points)." }
      ],
      "error": {
        "required": "This is a mandatory field.",
        "pattern": "Please enter a whole number only (no decimal points)."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    }
  ]
}
